import defaultReducer from "./defaultReducer";

export const COMPLIANCE_SUMMARY_TAB_KEY = "COMPLIANCE_SUMMARY_TAB";
export const EVENT_DETAILS_TAB_KEY = "EVENT_DETAILS_TAB_KEY";

// @TODO: Rename and segregate?
export const complianceSummaryTabReducer = defaultReducer(
  COMPLIANCE_SUMMARY_TAB_KEY,
  {
    section: null,
    activeIndex: 0,
    totalRecords: 0,
    expanded: false,
    filtersLoading: false,
    gridLoading: false,
    graphLoading: false,
    formLoading: false,
    hideDetails: false,
    complianceRecord: {
      id: null,
      rowVersion: null,
      isReadOnly: false,
    },
    quarter: {
      incompleteRecords: null,
      canBeProcessed: false,
      quarterName: "",
      startDate: null,
      endDate: null,
      year: null,
    },
    statusCounts: [],
    filters: {
      activePage: 1,
      periods: [],
      status: [],
      processedQuarters: [],
      selfExclusionTypes: [],
      eventTypes: [],
      incidentTypes: [],
      selectedPeriod: null,
      selectedQuarter: null,
      selectedEventType: [],
      selectedSelfExclusionType: [],
      selectedIncidentType: [],
      selectedStatuses: [],
      startDate: null,
      endDate: null,
      allNames: null,
    },
    grid: [],
    eventsGridLoading: false,
    eventsGrid: [],
    eventsGridActiveRow: null,
    incident: { record: { incidentType: { name: null } } },
    graph: {
      symbol: "",
      lines: [],
      data: [],
    },
    showDateRangeModal: false,
  },
);
